import { render, staticRenderFns } from "./TopDevices.vue?vue&type=template&id=da81132e&scoped=true&"
import script from "./TopDevices.vue?vue&type=script&lang=js&"
export * from "./TopDevices.vue?vue&type=script&lang=js&"
import style0 from "./TopDevices.vue?vue&type=style&index=0&id=da81132e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da81132e",
  null
  
)

export default component.exports